export function workflowConfigKey(config) {
  const c = config || {};
  return JSON.stringify({
    steps: (c.steps || []).map((s, i) => [s.da_id, i ? (s.step_op || 'join') : '', i ? (s.join_type || 'JOIN') : '', s.join_on_sql || '']),
    output_columns: c.output_columns || [],
    calculated_columns: c.calculated_columns || [],
    output_filters: c.output_filters || [],
  });
}
